"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _urijs = _interopRequireDefault(require("urijs"));

var _ExperimentDescription = _interopRequireDefault(require("./ExperimentDescription.js"));

var _Footer = _interopRequireDefault(require("./Footer.js"));

var _ChartContainer = _interopRequireDefault(require("../manipulate/ChartContainer.js"));

var _jsonPayloadPropTypes = _interopRequireDefault(require("./jsonPayloadPropTypes.js"));

var _main = _interopRequireDefault(require("../load/main.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Container = function Container(props) {
  var data = props.data,
      outProxy = props.outProxy,
      atlasUrl = props.atlasUrl,
      isWidget = props.isWidget;
  var _data$config = data.config,
      geneQuery = _data$config.geneQuery,
      conditionQuery = _data$config.conditionQuery,
      species = _data$config.species;
  var moreInformationUrl = data.experiment ? // single experiment?
  (0, _urijs["default"])(data.experiment.urls.main_page, atlasUrl) : (0, _urijs["default"])(atlasUrl).segment("query").search({
    geneQuery: geneQuery,
    conditionQuery: conditionQuery,
    species: species
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: "100%"
    }
  }, isWidget && data.experiment && /*#__PURE__*/_react["default"].createElement(_ExperimentDescription["default"], {
    outProxy: outProxy,
    experimentUrl: (0, _urijs["default"])(data.experiment.urls.main_page, atlasUrl).toString(),
    description: data.experiment.description
  }), /*#__PURE__*/_react["default"].createElement(_ChartContainer["default"], {
    chartData: (0, _main["default"])(props)
  }), isWidget && /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
    outProxy: outProxy,
    atlasUrl: atlasUrl,
    moreInformationUrl: moreInformationUrl.toString()
  }));
};

Container.propTypes = {
  inProxy: _propTypes["default"].string.isRequired,
  outProxy: _propTypes["default"].string.isRequired,
  atlasUrl: _propTypes["default"].string.isRequired,
  showAnatomogram: _propTypes["default"].bool.isRequired,
  isWidget: _propTypes["default"].bool.isRequired,
  data: _jsonPayloadPropTypes["default"].isRequired
};
var _default = Container;
exports["default"] = _default;